import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const HeadlineText = styled.p`
  font-size: 24px;
  font-weight: normal;
  color: ${props => props.theme.PRIMARY}
`;

function FormHeadline({ headline, id }) {
  return (
    <HeadlineText id={id}>
      { headline }
    </HeadlineText>
  );
}

FormHeadline.propTypes = {
  headline: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default FormHeadline;
